import { DEEP_LINKS_REDIRECT_ORIGIN } from '../../../../../common/deep-links';

export const getHostAndOrigin = (): { host: string; origin: string } => {
  const hostForElectron = DEEP_LINKS_REDIRECT_ORIGIN.replace('https://', '');

  return { host: hostForElectron, origin: DEEP_LINKS_REDIRECT_ORIGIN };
};
